import * as React from 'react';
import { Marquage } from './iMonCompte';
import { renderProductImage, getItemLinkHref } from './RenderCommon';
import {formatPrice, getShopRefInStorage} from './MonCompteAction';
import Modal from 'react-responsive-modal';
import {getHostApi} from '../../utils';

interface RenderOrderDetailsLineProps {
  enabledPostProcessing?: boolean;
  panier: any;
  order: any;
  sav: string;
}

interface RenderOrderDetailsLineState {
  open: boolean;
}

export default class RenderOrderDetailsLine extends React.Component<RenderOrderDetailsLineProps, RenderOrderDetailsLineState> {
  constructor(params: RenderOrderDetailsLineProps) {
    super(params);
    this.state = {
      open: false,
    };
  }

  onOpenModal = () => {
    this.setState({ open: true });
  }

  onCloseModal = () => {
    this.setState({ open: false });
  }

  render() {
    const renderProductTitle = () => {
      return (
        <p className="text-uppercase big bold">
          <a href={getItemLinkHref(this.props.panier.article)} className="black">{this.props.panier.article.produit.Titre}</a>
        </p>
      );
    };

    const renderProductRef = () => {
      return (
        <p className="mb-2">Réf {this.props.panier.article.produit.reference_visible}</p>
      );
    };

    const renderProductColor = () => {
      return (
        <p>Couleur : {this.props.panier.article.couleur.Couleur}</p>
      );
    };

    const renderProductSize = () => {
      return (
        <p>Taille : {this.props.panier.taille}</p>
      );
    };

    const renderPrint = () => {
      if(!this.props.panier.marquages) {
        return false;
      }

      const renderListMarquages = this.props.panier.marquages.map((marquage: Marquage, index: number) => {
        let next = ', ';

        if (index === this.props.panier.marquages.length - 1) {
          next = '';
        }
        return (
          <span>{marquage.surface} {marquage.emplacement}{next} </span>
        );
      });

      return (
        <div>
          Surface : {renderListMarquages}
        </div>
      );
    };

    const renderMarquage = () => {
      const text = () => {
        if (this.props.panier.marquage && this.props.panier.marquage !== 'vierge' ) {
          if (this.props.panier.marquage === 'fonce') {
            return 'TopQuadri';
          }
          if (this.props.panier.marquage === 'clair') {
            return 'QuadriLuxe';
          }
          if (this.props.panier.marquage === 'serigraphie') {
            return 'SeriCoat';
          }
          if (this.props.panier.marquage.indexOf('pf_') !== -1) {
            return this.props.panier.marquage.charAt(3).toUpperCase() + this.props.panier.marquage.slice(4);
          }
          return this.props.panier.marquage.charAt(0).toUpperCase() + this.props.panier.marquage.slice(1);
        }
        return 'Aucun';
      };
      return (
        <div>
          Marquage : {text()}
          {(this.props.panier.nb_couleurs_marquage !== null && this.props.panier.marquage && typeof this.props.panier.couleurs_marquage != "undefined") &&
            <>
          &nbsp;{this.props.panier.nb_couleurs_marquage} couleur(s)
          </>
          }
          {(this.props.panier.couleurs_marquage !== null && typeof this.props.panier.couleurs_marquage != "undefined" && this.props.panier.marquage) &&
          <>
            &nbsp;({this.props.panier.couleurs_marquage})
          </>
          }
        </div>
      );
    };

    const renderDimensions = () => {
      if(this.props.panier.dimensions && this.props.panier.dimensions.largeur && this.props.panier.dimensions.hauteur) {
        return (
          <div className={'small'}>Dimensions : {this.props.panier.dimensions.largeur}cm x {this.props.panier.dimensions.hauteur}cm</div>
        )
      }
    }

    const renderContour = () => {
      if(this.props.panier.marquages && this.props.panier.marquages[0] && this.props.panier.contourCmjn !== []) {
        const surfaceEmplacementId = this.props.panier.marquages[0].surface_emplacement_id;
        const contourCmjn = this.props.panier.contourCmjn[surfaceEmplacementId];
        if(contourCmjn) {
          return (
              <div className={'small'}>
                <span>Contour: </span>
                <span>C: {contourCmjn.cyan} M: {contourCmjn.magenta} J: {contourCmjn.jaune} N: {contourCmjn.noir} </span>
                <span className={"pl-3 pr-3"} title={`C: ${contourCmjn.cyan} M: ${contourCmjn.magenta} J: ${contourCmjn.jaune} N: ${contourCmjn.noir}`}
                      style={{border: "1px solid black", backgroundColor: `#${contourCmjn.hexadecimal}`}}>&nbsp;</span>
              </div>
          )
        }
      }
      return <></>;
    }

    const renderInfosProduits = () => {
      const ref = getShopRefInStorage();

      return (
        <div className="col-md-6">
          {renderProductTitle()}
          { ref !== 'DT' &&
          <>
            {renderProductRef()}
            {renderProductColor()}
            {renderProductSize()}
          </>
          }
          { ref !== 'MT' && ref !== 'ME' && ref !== 'DT' && !this.props.order.AucunMarquage ? (
            <div>
              {renderPrint()}
              {renderMarquage()}
            </div>
          ) : (
            <div></div>
          )}
          {ref == 'DT' &&
          <> {renderDimensions()}
             {renderContour()}
          </>
          }
        </div>
      );
    };

    const renderQuantityProduct = () => {
      return (
        <p>Quantité {this.props.panier.Quantite}</p>
      );
    };

    const renderUnitPriceProduct = () => {
      if (parseInt(this.props.sav) === 0) {
        return (
          <p>P.U {formatPrice(Number(this.props.panier.prixUnitaire).toFixed(2))} &euro;<sup> ht</sup></p>
        );
      }
    };

    const renderTotalPriceProduct = () => {
      if (parseInt(this.props.sav) === 0) {
        return (
          <p className="bold">Total : {formatPrice(this.props.panier.prixTotal)} &euro;<sup> ht</sup></p>
        );
      }
    };

    const renderMontantsProduit = () => {
      return (
        <div className="col-md-3 text-right d-flex flex-column justify-content-between position-relative">
          <div>
            {renderQuantityProduct()}
            {renderUnitPriceProduct()}
          </div>
          <div className="">
            {renderTotalPriceProduct()}
          </div>
        </div>
      );
    };

    const renderModalApplatME = (creationId: string) => {
      const ref = getShopRefInStorage();
      let url = `${getHostApi()}/customers/${this.props.order.Client_idClient}/orders/${this.props.order.idCommande}/image-files?nom=${creationId}.jpg&numCommande=${this.props.order.numCommande}&path=&validated=true&xsrf=${localStorage.getItem('xsrfToken')}`;
      let classAlpha = '';
      let classModal = 'applatMeModalContainer';
      let classDiv = 'text-center';
      let classImg = '';
      if(ref == 'DT' && Array.isArray(this.props.panier.marquages)) {
        classAlpha = 'bg-alpha';
        classModal = 'zoomModalContainer';
        classDiv = 'p-3';
        classImg = 'img-fluid';
        const filename = `preview_${this.props.panier.creation_id}-${this.props.panier.marquages[0].surface_emplacement_id}.png`;
        url = `${getHostApi()}/customers/${this.props.order.Client_idClient}/orders/${this.props.order.idCommande}/image-files?nom=${filename}&numCommande=${this.props.order.numCommande}&path=travail.auto/miniatures/&validated=true&xsrf=${localStorage.getItem('xsrfToken')}`;
      }
      return (
        <Modal open={this.state.open} onClose={this.onCloseModal} center
               classNames={{overlay: 'bootstrap-container', modal: `${classModal} customModal`,
                 closeButton: 'applatMeModalCloseButton closeButton'}}>
          <div className={classDiv}>
            <div className={classAlpha}>
            <img src={url} alt="" width="auto" height="auto" className={classImg}/>
            </div>
          </div>
        </Modal>
      );
    };

    return (
      <div className="d-flex flex-row justify-content-between orderDetailLine flex-column-mobile">
        {renderProductImage(this.props.panier, renderModalApplatME(this.props.panier.creation_id), this.onOpenModal, this.props.order)}
        {renderInfosProduits()}
        {renderMontantsProduit()}
      </div>
    );
  }
}
